<script>
  import fetchAdminAPI from './adminApi.js';
  import { onMount, afterUpdate } from 'svelte';
  // Разделы админки
  import TasksAdmin from './admin/TasksAdmin.svelte';
  import DailyRewardsAdmin from './admin/DailyRewardsAdmin.svelte';
  import RouletteSectorsAdmin from './admin/RouletteSectorsAdmin.svelte';
  import UsersAdmin from './admin/UsersAdmin.svelte';
  import PrizesAdmin from './admin/PrizesAdmin.svelte';
  import SpinLogsAdmin from './admin/SpinLogsAdmin.svelte';

  export let authData; // Предполагается, что это initData админа
  export let isAdminView; // Предполагается, что это initData админа

  let activeSection = 'tasks'; // 'tasks', 'daily-rewards', 'roulette-sectors', 'users', 'prizes', 'spin-logs'
  let error = null;


  function navigate(section) {
    activeSection = section;
  }

  const sections = {
    tasks: TasksAdmin,
    'daily-rewards': DailyRewardsAdmin,
    'roulette-sectors': RouletteSectorsAdmin,
    users: UsersAdmin,
    prizes: PrizesAdmin,
    'spin-logs': SpinLogsAdmin,
  };
  afterUpdate(() => {
    if (isAdminView) {
      document.body.classList.add('admin-view-active');
    } else {
      document.body.classList.remove('admin-view-active');
    }
  });
</script>

<div class="admin-panel-wrapper">
        
  <div class="stars-background">
    <div class="stars stars1"></div>
    <div class="stars stars2"></div>
    <div class="stars stars3"></div>
  </div>

    
  {#if error}
    <div class="error-message-global">{error}</div>
  {:else if !isAdminView}
    <div class="loading-admin">
      <div class="spinner-large"></div>
      Аутентификация администратора...
    </div>
  {:else}
    <header class="admin-header">
      <h1>Панель Администратора</h1>
      <nav class="admin-nav">
        <button class:active={activeSection === 'tasks'} on:click={() => navigate('tasks')}>Задания</button>
        <button class:active={activeSection === 'daily-rewards'} on:click={() => navigate('daily-rewards')}>Ежедневные</button>
        <button class:active={activeSection === 'roulette-sectors'} on:click={() => navigate('roulette-sectors')}>Рулетка</button>
        <button class:active={activeSection === 'users'} on:click={() => navigate('users')}>Пользователи</button>
        <button class:active={activeSection === 'prizes'} on:click={() => navigate('prizes')}>Призы</button>
        <button class:active={activeSection === 'spin-logs'} on:click={() => navigate('spin-logs')}>Логи</button>
      </nav>
    </header>

    <main class="admin-content-area">
      {#if sections[activeSection]}
        <svelte:component this={sections[activeSection]} {authData} />
      {:else}
        <div class="placeholder-content">
          <p>Добро пожаловать! Выберите раздел для управления.</p>
        </div>
      {/if}
    </main>
  {/if}
</div>

<style>
  /* --- Базовые стили для админ-панели в темной теме --- */
  :global(body.admin-view-active) {
    background: radial-gradient(ellipse at bottom, #1B2735 0%, #090A0F 100%);
    color: #E1E9F0; /* Светлый текст по умолчанию */
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    margin: 0;
    overflow-x: hidden;
    overflow-y: auto !important;
  }

  .admin-panel-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    position: relative; /* Для звездного фона */
    z-index: 1;
  }

  /* Звездный фон (копируем из вашего примера) */
  .stars-background {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    width: 100%; height: 100%;
    display: block;
    overflow-x: hidden;
    overflow-y: auto !important;
    z-index: -1;
  }
  .stars { /* Общий класс для звезд */
    position: absolute; top: 0; left: 0; right: 0; bottom: 0;
    width: 100%; height: 100%; display: block;
    background: transparent; background-repeat: repeat; background-size: cover;
    animation: moveStarsAdmin 150s linear infinite alternate; /* Другое имя анимации, если нужно */
  }
  @keyframes moveStarsAdmin { /* Переименовано, чтобы не конфликтовать, если App.svelte тоже использует moveStars */
    from { transform: translate(0, 0); }
    to { transform: translate(-100px, -150px); }
  }
  .stars1 { background-image: radial-gradient(1px 1px at 20px 30px, #9DB2BF, rgba(0,0,0,0)), radial-gradient(1px 1px at 40px 70px, #FFFFFF, rgba(0,0,0,0)), radial-gradient(1px 1px at 50px 160px, #C7D4DD, rgba(0,0,0,0)), radial-gradient(2px 2px at 90px 40px, #FFFFFF, rgba(0,0,0,0)), radial-gradient(1px 1px at 130px 80px, #9DB2BF, rgba(0,0,0,0)), radial-gradient(1px 1px at 160px 120px, #C7D4DD, rgba(0,0,0,0)); background-size: 200px 200px; animation-duration: 200s; opacity: 0.5; }
  .stars2 { background-image: radial-gradient(1px 1px at 10px 50px, #9DB2BF, rgba(0,0,0,0)), radial-gradient(1px 1px at 60px 90px, #FFFFFF, rgba(0,0,0,0)), radial-gradient(2px 2px at 100px 150px, #C7D4DD, rgba(0,0,0,0)), radial-gradient(1px 1px at 140px 30px, #FFFFFF, rgba(0,0,0,0)), radial-gradient(1px 1px at 180px 100px, #9DB2BF, rgba(0,0,0,0)); background-size: 250px 250px; animation-duration: 300s; opacity: 0.6; }
  .stars3 { background-image: radial-gradient(2px 2px at 5px 5px, #FFFFFF, rgba(0,0,0,0)), radial-gradient(1px 1px at 80px 40px, #C7D4DD, rgba(0,0,0,0)), radial-gradient(1px 1px at 120px 180px, #9DB2BF, rgba(0,0,0,0)), radial-gradient(1px 1px at 170px 60px, #FFFFFF, rgba(0,0,0,0)); background-size: 300px 300px; animation-duration: 400s; opacity: 0.4; }


  .admin-header {
    background-color: rgba(10, 15, 20, 0.7);
    backdrop-filter: blur(10px) saturate(150%);
    color: #E1E9F0;
    padding: 18px 25px;
    border-bottom: 1px solid rgba(135, 195, 255, 0.15);
    position: sticky;
    top: 0;
    z-index: 100;
  }
  .admin-header h1 {
    margin: 0 0 12px 0;
    font-size: 1.7rem;
    font-weight: 700;
    background: linear-gradient(90deg, #87C3FF, #B4DFFF);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 0 8px rgba(135, 195, 255, 0.3);
  }

  .admin-nav {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }
  .admin-nav button {
    padding: 9px 16px;
    border: 1px solid rgba(135, 195, 255, 0.2);
    background-color: rgba(135, 195, 255, 0.08);
    color: #A6C5E1;
    cursor: pointer;
    border-radius: 8px;
    font-size: 0.9em;
    font-weight: 600;
    transition: all 0.25s ease;
  }
  .admin-nav button:hover {
    background-color: rgba(135, 195, 255, 0.15);
    border-color: rgba(135, 195, 255, 0.3);
    color: #FFFFFF;
    transform: translateY(-1px);
  }
  .admin-nav button.active {
    background: linear-gradient(45deg, #4A90E2, #61A6FF);
    color: white;
    border-color: transparent;
    box-shadow: 0 3px 10px rgba(74, 144, 226, 0.3);
  }

  .admin-content-area {
    padding: 20px 25px;
    flex-grow: 1;
  }
  .placeholder-content { /* Для приветственного сообщения */
    background-color: rgba(27, 39, 53, 0.7); /* Полупрозрачный фон */
    backdrop-filter: blur(5px);
    padding: 30px;
    border-radius: 12px;
    border: 1px solid rgba(135, 195, 255, 0.1);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
    text-align: center;
    font-size: 1.1em;
    color: #B0C4DE;
  }

  .error-message-global { /* Для общей ошибки, если authData не пришел */
    color: #ff8a80; /* Светло-красный */
    padding: 20px;
    background-color: rgba(255, 138, 128, 0.1);
    border: 1px solid rgba(255, 138, 128, 0.3);
    border-radius: 8px;
    margin: 20px;
    text-align: center;
  }
  .loading-admin {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 80vh; /* Чтобы не на весь экран, если хэдер есть */
    font-size: 1.1em;
    color: #A6C5E1;
    gap: 15px;
  }

  /* --- Глобальные стили для компонентов админки в темной теме --- */
  :global(.admin-section-header) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(135, 195, 255, 0.1);
  }
  :global(.admin-section-header h2) {
    font-size: 1.5rem;
    color: #E1E9F0;
    margin: 0;
    font-weight: 600;
    text-shadow: 0 1px 3px rgba(0,0,0,0.5);
  }

  :global(button.admin-create), :global(button.admin-primary) {
    background: linear-gradient(45deg, #4A90E2, #61A6FF);
    color: white;
    border: none;
    padding: 10px 18px;
    font-size: 0.9em;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 10px rgba(74, 144, 226, 0.25), 0 2px 3px rgba(0,0,0,0.2);
    display: inline-flex; /* для иконок */
    align-items: center; /* для иконок */
    justify-content: center; /* для иконок */
  }
  :global(button.admin-create:hover), :global(button.admin-primary:hover) {
    filter: brightness(1.15);
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(74, 144, 226, 0.3), 0 3px 5px rgba(0,0,0,0.25);
  }

  :global(.admin-card) {
    background-color: rgba(20, 30, 42, 0.75); /* Темный полупрозрачный фон */
    backdrop-filter: blur(8px) saturate(120%);
    padding: 20px 25px;
    border-radius: 12px;
    border: 1px solid rgba(135, 195, 255, 0.12);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
    margin-bottom: 25px;
  }

  :global(.admin-table) {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 1px; /* Тонкая линия между строками или без нее */
    margin-top: 15px;
  }
  :global(.admin-table th) {
    background-color: rgba(135, 195, 255, 0.08);
    color: #A6C5E1;
    font-weight: 600;
    text-align: left;
    padding: 12px 15px;
    font-size: 0.85em;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid rgba(135, 195, 255, 0.2);
  }
  :global(.admin-table td) {
    background-color: transparent; /* Строки таблицы будут на фоне карточки */
    padding: 12px 15px;
    font-size: 0.95em;
    color: #C0D0E0;
    border-bottom: 1px solid rgba(135, 195, 255, 0.08);
  }
  :global(.admin-table tbody tr:last-child td) {
    border-bottom: none;
  }
  :global(.admin-table tbody tr:hover td) {
    background-color: rgba(135, 195, 255, 0.05);
  }

  /* Кнопки действий в таблице */
  :global(.admin-actions button), :global(button.admin-action-button) {
    padding: 6px 10px;
    font-size: 0.8em;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-right: 6px;
    border: 1px solid transparent;
    font-weight: 500;
    background: transparent;
  }
  :global(button.admin-edit) { border-color: #60a5fa; color: #93c5fd; } /* Голубой */
  :global(button.admin-edit:hover) { background-color: rgba(96, 165, 250, 0.2); color: #dbeafe; }
  :global(button.admin-delete) { border-color: #f87171; color: #fca5a5; } /* Красный */
  :global(button.admin-delete:hover) { background-color: rgba(248, 113, 113, 0.2); color: #fee2e2; }
  :global(button.admin-award) { border-color: #34d399; color: #6ee7b7; } /* Зеленый */
  :global(button.admin-award:hover) { background-color: rgba(52, 211, 153, 0.2); color: #d1fae5; }
  :global(button.admin-save) { border-color: #34d399; color: #6ee7b7; }
  :global(button.admin-save:hover) { background-color: rgba(52, 211, 153, 0.2); color: #d1fae5; }
  :global(button.admin-cancel) { border-color: #9ca3af; color: #d1d5db; }
  :global(button.admin-cancel:hover) { background-color: rgba(156, 163, 175, 0.2); color: #f3f4f6; }


  /* Формы и модальные окна */
  :global(.admin-form label) {
    display: block;
    margin-top: 12px;
    margin-bottom: 6px;
    font-weight: 500;
    font-size: 0.9em;
    color: #A6C5E1;
  }
  :global(.admin-form input[type="text"],
          .admin-form input[type="number"],
          .admin-form input[type="url"],
          .admin-form input[type="email"],
          .admin-form input[type="color"], /* Цвет инпута color может быть проблемой */
          .admin-form select,
          .admin-form textarea) {
    width: 100%;
    padding: 10px 12px;
    background-color: rgba(10, 20, 30, 0.8);
    border: 1px solid rgba(135, 195, 255, 0.3);
    border-radius: 6px;
    box-sizing: border-box;
    font-size: 0.95em;
    color: #E1E9F0;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }
  :global(.admin-form input[type="color"]) { /* Специфично для input type color */
     height: 40px; /* Для лучшего вида */
     padding: 3px;
  }
  :global(.admin-form input:focus, .admin-form select:focus, .admin-form textarea:focus) {
    border-color: #61A6FF;
    box-shadow: 0 0 0 0.15rem rgba(97, 166, 255, 0.3);
    outline: none;
    background-color: rgba(15, 25, 35, 0.9);
  }
  :global(.admin-form input[type="checkbox"]) {
    margin-right: 8px;
    vertical-align: middle;
    width: auto;
    height: 16px; width: 16px;
    accent-color: #61A6FF; /* Цвет галочки */
    background-color: rgba(10,20,30,0.8);
    border: 1px solid rgba(135,195,255,0.3);
  }
   :global(.admin-form input[type="checkbox"] + span) { /* текст рядом с чекбоксом */
     color: #A6C5E1;
   }
  :global(.admin-form .form-actions) {
    margin-top: 25px;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
  }
  :global(button.admin-secondary) { /* Кнопка Отмена в формах */
    background: transparent;
    color: #A6C5E1;
    border: 1px solid rgba(135, 195, 255, 0.3);
    padding: 10px 18px;
    font-size: 0.9em;
    border-radius: 8px;
  }
  :global(button.admin-secondary:hover) {
    background-color: rgba(135, 195, 255, 0.1);
    border-color: rgba(135, 195, 255, 0.4);
  }

  :global(.modal) {
    
    position: fixed;
    top: 0; left: 0; width: 100%; height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(5px);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 1001;
    padding: 20px;
    box-sizing: border-box;
  }
  :global(.modal-content) {
    background: linear-gradient(160deg, #1A2C3D, #101A24);
    padding: 20px 20px; /* Уменьшим внутренние отступы для мобильных */
    border-radius: 12px;
    /* min-width: 400px;  УБИРАЕМ или сильно уменьшаем min-width для мобильных */
    width: 100%; /* ЗАСТАВЛЯЕМ занимать доступную ширину с учетом padding родителя (.modal) */
    max-width: 550px; /* Ограничение для десктопа, можно подстроить */
    max-height: calc(100vh - 40px); /* Занимает почти всю высоту, оставляя отступы */
    overflow-y: auto; /* Скролл для контента модалки */
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(135, 195, 255, 0.15);
    animation: modalFadeInDark 0.3s ease-out;
    margin-top: 20px; /* Отступ сверху на мобильных, если align-items: flex-start */
    margin-bottom: 20px; /* Отступ снизу, чтобы кнопки не прилипали */
    box-sizing: border-box; /* Важно! */
  }
  @keyframes modalFadeInDark { from { opacity: 0; transform: scale(0.95) translateY(-10px); } to { opacity: 1; transform: scale(1) translateY(0); } }

  :global(.modal-content h3) {
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 1.4rem;
    color: #87C3FF; /* Светло-голубой заголовок модалки */
    font-weight: 600;
    text-shadow: 0 1px 2px rgba(0,0,0,0.5);
  }

  :global(.pagination) {
    margin-top: 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.9em;
    color: #A6C5E1;
    padding: 10px 0;
    border-top: 1px solid rgba(135, 195, 255, 0.1);
  }
  :global(.pagination .page-controls button) {
    margin: 0 5px;
    padding: 7px 12px;
    border-color: rgba(135, 195, 255, 0.3);
    color: #A6C5E1;
  }
  :global(.pagination .page-controls button:hover:not(:disabled)) {
    background-color: rgba(135, 195, 255, 0.1);
    border-color: rgba(135, 195, 255, 0.4);
  }
  :global(.pagination .page-controls button:disabled) {
    opacity: 0.5;
    cursor: not-allowed;
  }
  :global(.pagination .page-controls select) {
    padding: 8px;
    margin-left: 10px;
    border-radius: 6px;
    background-color: rgba(10, 20, 30, 0.8);
    border: 1px solid rgba(135, 195, 255, 0.3);
    color: #E1E9F0;
  }
  :global(.pagination .page-controls select option) {
    background-color: #1B2735; /* Фон для опций */
    color: #E1E9F0;
  }


  /* Спиннеры */
  :global(.spinner-large) {
    border: 4px solid rgba(135, 195, 255, 0.2);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-left-color: #87C3FF;
    animation: spin 1s ease infinite;
  }
  :global(.spinner-small) {
    border: 2px solid rgba(135, 195, 255, 0.2);
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border-left-color: #87C3FF;
    animation: spin 0.8s ease infinite;
    display: inline-block;
    vertical-align: middle;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  :global(.filters-bar) {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    align-items: center;
    margin-bottom: 20px;
    padding: 15px 20px;
    background-color: rgba(15, 25, 35, 0.7);
    backdrop-filter: blur(5px);
    border-radius: 10px;
    border: 1px solid rgba(135, 195, 255, 0.1);
  }
  :global(.filters-bar input[type="text"]), :global(.filters-bar select) {
    flex-grow: 1;
  }
  :global(.filters-bar button) {
     padding: 9px 15px;
  }

  @media (max-width: 480px) {
    :global(.modal-content) {
      padding: 15px; /* Еще меньше отступы */
      margin-top: 15px;
      margin-bottom: 15px;
      max-height: calc(100vh - 30px);
    }
    :global(.modal-content h3) {
      font-size: 1.2rem; /* Уменьшаем заголовок */
      margin-bottom: 15px;
    }
    :global(.admin-form label) {
      font-size: 0.85em;
    }
    :global(.admin-form input[type="text"]),
    :global(.admin-form input[type="number"]),
    :global(.admin-form input[type="url"]),
    :global(.admin-form input[type="email"]),
    :global(.admin-form select),
    :global(.admin-form textarea) {
      padding: 9px 10px; /* Компактнее инпуты */
      font-size: 0.9em;
    }
    :global(.admin-form .form-actions) {
      flex-direction: column-reverse; /* Кнопки друг под другом, "Создать" снизу */
      gap: 12px;
    }
    :global(.admin-form .form-actions button) {
      width: 100%; /* Кнопки на всю ширину */
      margin-left: 0 !important; /* Если был отступ */
    }
  }
</style>